
// javascript/controllers/push_state_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.debounceSubmit = this.debounce(this.debounceSubmit, 500)
  }

  formSubmit(event) {
    const url = new URL(window.location.href.split("?")[0])
    let formData = new FormData(event.target)
    let search = new URLSearchParams(formData)
    let stringUrl = url.toString() + "?" + search.toString()

    history.pushState({}, "", stringUrl);
    Turbo.navigator.history.replace(stringUrl)
  }

  debounceSubmit(event) {
    this.element.requestSubmit()
  }

  debounce(func, delay = 1000) {
    let debounceTimer
    return function () {
      const context = this
      const args = arguments
      clearTimeout(debounceTimer)
      debounceTimer = setTimeout(() => func.apply(context, args), delay)
    }
  }
}